require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-empowering-community-colleges-for-economic-change.json") })
        }
      }, "path---blog-empowering-community-colleges-for-economic-change");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-empowering-community-colleges-for-economic-change!./.cache/json/blog-empowering-community-colleges-for-economic-change.json
// module id = 797
// module chunks = 231608221292675